export default {
    routerName: '刊物编辑',
    journal: {
        title: 'タイトル',
        type: 'タイプ',
        monthJournal: '月刊',
        dayJournal: '日刊',
        image: '刊物アイコン',
        thumb: '缩略图',
        releaseDate: '発刊日付',
        body: '目録',
        description: '記述',
        sortOrder: 'ソート',
        status: '状態',
        open: '有効',
        close: '無効',
    },
};
